import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';

import {CardTable} from 'views/module';

import Card from './Card';

import backend from 'utils/backend';

const List = (props) => {
  const [data, setData] = React.useState([]);
  const [lastEvaluatedKey, setLastEvaluatedKey] = React.useState();
  const [stage, setStage] = React.useState('FILL');

  const progressWrap = props.statusProgressWrap;
  const selection = props.selection;
  const reload = props.reload;

  const isLoading = stage === 'LOADING';

  const loadData = () => {
    progressWrap(async () => {
      const filter = [];

      for (const filterSelected of Object.values(selection.filter)) {
        filter.push(
            {
              key: filterSelected.filterData.key,
              value: filterSelected.optionSelected,
            },
        );
      }

      const sortBy = {
        sortKey: 'createdAt',
        sortDirection: 'DESC',
      };

      const result = await backend.clientLead.queryClientLead(filter, sortBy, lastEvaluatedKey);
      setData((e) => {
        return [
          ...e,
          ...result.list,
        ];
      });
      setLastEvaluatedKey(result.lastEvaluatedKey);
    }, {setStage, showProgress: false});
  };

  React.useEffect(() => {
    setData([]);
    setLastEvaluatedKey(null);
    loadData();
  }, [selection, reload]);


  return (
    <Grid container>
      <CardTable
        data={data}
        card={Card}
        isLoading={isLoading}
        loadMore={loadData}
        hasMore={!!lastEvaluatedKey}
      />
    </Grid>
  );
};
List.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
  selection: PropTypes.object.isRequired,
  reload: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
